import { BaseStore } from "../stores/base_store"
import { runInAction, makeAutoObservable } from "mobx"
import BioAPI from "../api/bio_api"

export type BioProps = {
    key: string;

    date_created: string;
    date_updated: string;
    updateProps?: (attributes: BioProps) => void;
};

// Domain object Bio
export class Bio implements BioProps {
    key = "";

    date_created = "";
    date_updated = "";

    constructor(attributes: BioProps) {
        makeAutoObservable(this, {
            updateProps: false
        })
        if (attributes) {
            this.updateProps(attributes);
        }
    }

    updateProps(attributes: BioProps) {
        runInAction(() => {
            Object.assign(this, attributes);
        });
    }
}


export class BioStore extends BaseStore<BioProps, Bio> {


    async fetchBio(key: string) {
        return BioAPI.load(key).then((data: BioProps) => {
            this.receiveUpdate(data);
        });
    }

    modelConstructor() {
        return Bio;
    }

}
